import { render, staticRenderFns } from "./ServiceRowGroup.vue?vue&type=template&id=5fb6df64&scoped=true&"
import script from "./ServiceRowGroup.vue?vue&type=script&lang=js&"
export * from "./ServiceRowGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6df64",
  null
  
)

export default component.exports